import {Box, Typography} from "@mui/material";

function Main({title, actions, children}) {
    return (
        <main className={'App-main'}>
            <Typography variant={'h1'} fontSize={'xxx-large'} sx={{marginBottom: '10px'}}>{title}</Typography>
            <Box sx={{marginBottom: '15px'}}>
                {actions}
            </Box>
            {children}
        </main>
    );
}

export default Main;